const apiStatusStates = {
  apiStatus: ''
}

export default apiStatusStates



// WEBPACK FOOTER //
// ./src/utils/store/apiStatusStates.js